import React, { createContext, useContext, useState, useEffect } from 'react';

const CurrencyContext = createContext();

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return context;
};

export const CurrencyProvider = ({ children }) => {
  // Get saved currency from localStorage or default to CAD
  const [currency, setCurrency] = useState(() => {
    const saved = localStorage.getItem('selectedCurrency');
    return saved || 'CAD';
  });

  // Conversion rate: 1 CAD = 0.73 USD (you can update this as needed)
  const conversionRate = 0.73;

  // Save currency preference to localStorage
  useEffect(() => {
    localStorage.setItem('selectedCurrency', currency);
  }, [currency]);

  // Convert price based on selected currency
  const convertPrice = (priceCAD) => {
    if (currency === 'USD') {
      return priceCAD * conversionRate;
    }
    return priceCAD;
  };

  // Format price with currency symbol and thousand separators
  const formatPrice = (priceCAD) => {
    const convertedPrice = convertPrice(priceCAD);
    const currencyCode = currency;
    
    // Use toLocaleString to add thousand separators (e.g., 1,234.56)
    const formattedNumber = convertedPrice.toLocaleString('en-CA', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    
    return `$${formattedNumber} ${currencyCode}`;
  };

  const value = {
    currency,
    setCurrency,
    convertPrice,
    formatPrice,
    conversionRate
  };

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};

export default CurrencyContext;
